import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "@/features/auth/authSlice";
import api from "@/services/api";
import LogoAppWhoop from "@/assets/appwhoop_ticket_logo.webp";

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const code = searchParams.get("code");
    const error = searchParams.get("error");

    if (error || !code) {
      navigate("/login?error=google");
      return;
    }

    const redirectUri = `${window.location.origin}/auth/callback`;

    api
      .post("/auth/google-callback", { code, redirect_uri: redirectUri })
      .then(({ data }) => {
        dispatch(
          loginSuccess({
            user: data.user,
            accessToken: data.AuthenticationResult.AccessToken,
            idToken: data.AuthenticationResult.IdToken,
          })
        );
        const returnTo = sessionStorage.getItem("auth_return_to");
        sessionStorage.removeItem("auth_return_to");
        const isValid =
          returnTo?.startsWith("/evento/") || returnTo?.startsWith("/experiencias/");
        navigate(isValid ? returnTo : "/");
      })
      .catch(() => {
        navigate("/login?error=google");
      });
  }, []);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-aw-bluedark">
      <div className="text-center text-white">
        <img src={LogoAppWhoop} alt="AppWhoop" className="w-24 h-auto mx-auto mb-6 opacity-80" />
        <div className="w-10 h-10 border-4 border-aw-green border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-white/60">Completando inicio de sesión...</p>
      </div>
    </div>
  );
}
